// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// --- RxJs
import { Observable, of, switchMap } from 'rxjs';

// --- HS Code
import { EnrichedUserDetailsBaseService, OidcService } from '../services';

// #endregion

export const userDetailsGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const currentState = state;
    const router: Router = inject(Router);
    const oidcService: OidcService = inject(OidcService);
    const enrichedUserDetailsService: EnrichedUserDetailsBaseService = inject(EnrichedUserDetailsBaseService);

    return enrichedUserDetailsService.areEnrichedDetailsRequired().pipe(
      switchMap((areUserDetailsRequired): Observable<boolean | UrlTree> => {

        const stateUrl = currentState.url.replace('/', '');

        if (!areUserDetailsRequired) {
          if (stateUrl?.toLocaleLowerCase().startsWith('dashboard')) {
            return of(true);
          } else {
            return of(router.createUrlTree(['/dashboard']));
          }
        } else {
          if (stateUrl?.toLocaleLowerCase() === 'dashboard') {
            return of(router.createUrlTree(['/user-details']));
          } else {
            return of(true);
          }
        }
      })
    );
}

